<script>
    // Import general mixin for shared functionality.
    import mixin from './../mixin';

    import SourceSet from './SourceSet.vue';

    export default {
        mixins: [mixin],
        components: { SourceSet },
        props: {
            item: Object,
            culture: {
                type: String,
                default: 'nl-NL'
            }
        }
    }
</script>

<template>
    <a :href="item.detailUrl" class="card card--imagelink is-flex is-flex-direction-column">
        <source-set :imageSets="item.image" alias="previewImagePortrait_" class-name="card-image is-clipped" v-if="item.image && item.image.length"/>
        <div class="card-content is-flex-grow-1 is-flex is-flex-direction-column px-0 py-3">
            <time v-if="item.date" class="is-uppercase is-size-11 mb-3 is-family-secondary has-text-weight-medium" :datetime="item.date">{{ toDateStr(item.date, culture) }}</time>
            <h3 v-if="item.title" class="title is-7 has-text-weight-semibold">{{ item.title }}</h3>
        </div>
    </a>
</template>
